/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_My_OrdersInputs */

const vi_dashboard_sales_my_orders = /** @type {(inputs: Dashboard_Sales_My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn của tôi tháng này`)
};

/**

* @param {Dashboard_Sales_My_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_my_orders = /** @type {((inputs?: Dashboard_Sales_My_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_My_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_my_orders(inputs)
});